import { getExtraData } from './userAgent'
import { getNativeBrowserInfo, getUserIp } from './clientInfo'

export const trackEvent = (eventType, data = {}) => {
  const extraData = getExtraData() || {}
  return {
    eventType,
    actionTime: Date.now(),
    ...extraData,
    ...data
  }
}

export const pageViewLog = (arg = {}) => {
  const extraData = getExtraData() || {}
  if (arg?.enterTime) {
    const deadTime = Date.now()
    return {
      eventType: 'PAGE_VIEW',
      pageView: {
        eventName: 'PAGE_VIEW',
        deadTime,
        stayTime: deadTime - arg.enterTime,
        ...extraData,
        ...arg
      }
    }
  }
}

export const loginLog = async (arg = {}) => {
  const userIp = await getUserIp()
  const nativeBrowserInfo = getNativeBrowserInfo()
  const clientInfo = { ...userIp, ...nativeBrowserInfo }
  return trackEvent('login', { ...clientInfo, ...arg })
}

export const userLog = (user = {}) => trackEvent('USER_INFO', user)
